<div class="sidebar-panel">
  <div>
    <div class="branding default-bg">
      <img src="assets/images/escritorios/TS-COBRA.png"  width="150px" alt="" class="app-logo">
    </div>
  </div>

  <div id="scroll-area" class="navigation-hold" fxLayout="column">
    <!-- App Logo -->
    <mat-divider class="mat-divider mat-divider-horizontal" role="separator" aria-orientation="horizontal"></mat-divider>

    <app-sidenav [items]="menuItems" [hasIconMenu]="hasIconTypeMenuItem" [iconMenuTitle]="iconTypeMenuTitle"></app-sidenav>
  </div>
</div>
